<script setup>
import ProductCard from "@/Components/Product/ProductCard.vue";
import Link from "@/Components/Buttons/Link.vue";
import {inject} from "vue";

const route = inject('route');

defineProps({
  title: String,
  products: Array,
});

</script>

<template>
    <div
        v-if="products?.length > 0"
        class="outer-container my-10 md:my-15"
    >
        <div class="flex-center">
            <div class="prose">
                <h2>
                    {{ title ?? $t('Related products') }}
                </h2>
            </div>
        </div>
        <div
            class="grid grid-cols-2 gap-8 pt-8 md:grid-cols-3 lg:grid-cols-4 lg:pb-12 lg:pt-16"
        >
            <div
                v-for="product in products"
                :key="product.id"
                class="relative flex-1"
            >
                <ProductCard :product="product" />
            </div>
        </div>

        <div class="flex-center">
            <Link
                :href="route('public.products.index')"
                :label="$t('All products')"
            />
        </div>
    </div>
</template>
